module.exports = __webpack_public_path__ + "static/media/BR.b81fef9f.png";